import { render, staticRenderFns } from "./Google1x1.vue?vue&type=template&id=56eb4c2b&"
import script from "./Google1x1.vue?vue&type=script&lang=js&"
export * from "./Google1x1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports